import type { SVGProps } from "react";

export const CarIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg fill="none" height="24" viewBox="0 0 24 24" width="24" {...props}>
		<path
			d="M5 13H8M2 9L4 10L5.27 6.19C5.53 5.40 5.66 5.01 5.91 4.72C6.12 4.46 6.40 4.26 6.71 4.14C7.06 4 7.48 4 8.31 4H15.69C16.52 4 16.94 4 17.29 4.14C17.60 4.26 17.88 4.46 18.09 4.72C18.34 5.01 18.47 5.40 18.73 6.19L20 10L22 9M16 13H19M6.8 10H17.2C18.88 10 19.72 10 20.36 10.33C20.93 10.61 21.39 11.07 21.67 11.64C22 12.28 22 13.12 22 14.8V17.5C22 17.96 22 18.20 21.96 18.39C21.80 19.18 21.18 19.80 20.39 19.96C20.20 20 19.96 20 19.5 20H19C17.90 20 17 19.10 17 18C17 17.72 16.78 17.5 16.5 17.5H7.5C7.22 17.5 7 17.72 7 18C7 19.10 6.10 20 5 20H4.5C4.04 20 3.80 20 3.61 19.96C2.82 19.80 2.20 19.18 2.04 18.39C2 18.20 2 17.96 2 17.5V14.8C2 13.12 2 12.28 2.33 11.64C2.61 11.07 3.07 10.61 3.64 10.33C4.28 10 5.12 10 6.8 10Z"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
		/>
	</svg>
);
